interface NewRelicApi {
  addPageAction?: (name: string, attributes?: Record<string, unknown>) => void;
  setCustomAttribute?: (key: string, value: unknown) => void;
}

const getNewRelic = (): NewRelicApi | undefined =>
  (window as unknown as { newrelic?: NewRelicApi }).newrelic;

export const nrAction = (name: string, attributes?: Record<string, unknown>): void => {
  getNewRelic()?.addPageAction?.(name, attributes);
};

export const nrAttribute = (key: string, value: unknown): void => {
  getNewRelic()?.setCustomAttribute?.(key, value);
};
